<template>
    <div class="Panel">
        <div class="Panel__heading">Order Form Orders</div>
        <div class="Panel__body">
            <paginator url="/admin/order-forms/list">
                <template v-slot:default="slotProps">
                    <div>
                        <div class="TableResponsive">
                            <table class="Table Table--striped Table--admin">
                                <thead>
                                <tr>
                                    <th class="w-px">Order Number</th>
                                    <th>Member Name</th>
                                    <th class="text-right">Total</th>
                                    <th>Status</th>
                                    <th class="w-px">Last Updated</th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="order in slotProps.items"
                                        @click="edit(order)"
                                    >
                                        <td>{{ order.id }}</td>
                                        <td>{{ order.member.name }}</td>
                                        <td class="text-right">€{{ order.formatted_total.toLocaleString(undefined, { miniumumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                                        <td>
                                            <div :class="`Pill Pill--${order.status.toLowerCase()}`">
                                                {{ order.status }}
                                            </div>
                                        </td>
                                        <td>{{ order.last_updated }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <div class="mt-4 flex items-center justify-between">
                            Showing page {{ slotProps.currentPage }} of {{ slotProps.pages }}
                            
                            <div class="flex ml-4 font-bold">
                                <a href="#"
                                   :class="{ 'text-gray': slotProps.currentPage === 1 }"
                                   @click.prevent="slotProps.previousPage"
                                >
                                    <i class="fa fa-chevron-left" aria-hidden="true"></i> Previous
                                </a>
                                <a href="#"
                                   class="ml-4"
                                   :class="{ 'text-gray': slotProps.currentPage === slotProps.pages }"
                                   @click.prevent="slotProps.nextPage"
                                >
                                    Next <i class="fa fa-chevron-right" aria-hidden="true"></i>
                                </a>
                            </div>
                            
                            <div></div>
                        </div>
                    </div>
                </template>
            </paginator>
        </div>
    </div>
</template>

<script>
    import Paginator from "../../Paginator";
    
	export default {
		components: { Paginator },
        
        methods: {
		    edit(order) {
                window.location = `/admin/order-forms/${order.id}/edit`;
            }
        }
	}
</script>
